<template>
  <div class="header-container">
    <h1>Header</h1>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  data() {
    return {}
  },// data
  methods: {},// methods
  watch: {
    // 'searchParamVo.topPath': {handler: function (val, oldVal) {if (val) {this.searchParamVo.topPath = val;this.searchParamVo.topPath = '';}}, deep: true},
  },// watch
  mounted() {
    // this.init();
  },// mounted
}
</script>

<style scoped>
.header-container {
  height: 60px;
  background-color: #409EFF;
  color: white;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.header-container h1 {
  margin: 0;
  font-size: 20px;
}
</style>